import React, { useEffect } from "react";
import { useSession } from "../context/SessionContext";
import { useNavigate } from "react-router-dom";
import LeadersTemplate from "../components/templates/LeadersTemplate";

const Leaders = () => {
    const { user } = useSession();
    const navigate = useNavigate();

    useEffect(() => {
        if (user && user.role !== "Admin") {
            navigate("/dashboard");
        }
    }, [user, navigate]);

    if (!user || user.role !== "Admin") {
        return null;
    }

    return <LeadersTemplate />;
};

export default Leaders;